import React, {
  useEffect, useState, useCallback, useRef,
} from 'react'
import { Box, Loader } from '@usap/uicomponents'
import ReturnDetailsHeader from './ReturnDetailsHeader'
import ReturnStatus from './ReturnStatus'
import ReturnDetailsItemInfo from './ReturnDetailsItemInfo'
import ReturnDetailsFooter from './ReturnDetailsFooter'
import LightboxShippingLabel from './ShippingLabelInstructions/LightboxShippingLabel'
import TempBreadcrumb from './TempBreadcrumb'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import ReturnDetailsWMO from './ReturnDetailsWMO'

export default function ReturnDetails({
  Link,
  isDesktop,
  creditStatus,
  returnReasonUtils,
  returnDetailsData,
  returnRequestStatus,
  setReturnDetailsData,
  setDisplayReturnDetails,
  OpenChatHandler,
  isCustomerTrackOrderRoute
}) {
  const { getReturnDetailsByRequestID } = returnReasonUtils
  const [returnData, setReturnData] = useState(false)
  const [dataChange, setDataChange] = useState(0)
  const [linkBreadcrumb, setLinkBreadcrumb] = useState([])
  const [shippingLabelLightboxInstruction, setShippingLabelLightboxInstruction] = useState(false)
  const [displayLightbox, setDisplayLightbox] = useState(false)
  const [origin, setOrigin] = useState('Order Details')
  const isWmoEnabled = useWmoEnabled()

  const breadCrumbElem = useRef(document.getElementById('breadCrumbList'))

  const generateBreadcrumb = useCallback(
    dataResponse => {
      const { orderId } = dataResponse.order
      const currentUrl = window.location.href.split('/')
      const isTrackOrder = currentUrl[currentUrl.length - 1].includes('trackorder')
      // Re-construct breadcrumb lists
      let links = [
        { text: 'My Account', value: '/myaccount' },
        { text: isTrackOrder ? 'Track Order' : 'Order History', value: isTrackOrder ? '/myaccount/trackorder' : '/myaccount/orderhistory' },
        { text: 'Order Details', value: `/myaccount/orderdetails?orderId=${orderId} ` },
        { text: 'Return Details', value: '' },
      ]
      if (!breadCrumbElem.current) {
        links = [
          { text: 'My Account', value: '/myaccount' },
          { text: 'Returns', value: `/myaccount/orderdetails?orderId=${orderId} ` },
          { text: 'Return Details', value: '' },
        ]
      }
      setLinkBreadcrumb(links)
      setOrigin(breadCrumbElem.current ? 'Order Details' : 'Returns')
      return true
    },
    [breadCrumbElem],
  )

  const getDataReturn = useCallback(
    async () => {
      const dataResponse = await getReturnDetailsByRequestID(returnDetailsData)
      setReturnData(dataResponse)
      generateBreadcrumb(dataResponse)
      setDataChange(Math.random())
    },
    [generateBreadcrumb, getReturnDetailsByRequestID, returnDetailsData],
  )

  const exitReturnDetails = () => {
    setLinkBreadcrumb([])
    setDisplayReturnDetails(false)
  }

  const getBoxPaddingValue = () => {
    if (isCustomerTrackOrderRoute) {
      return {
        top: isDesktop ? '9px' : 'small',
        bottom: isDesktop ? 'medium' : 'small',
        horizontal: isDesktop ? 'medium' : 'small',
      }
    }

    return isDesktop ? 'medium' : 'small'
  }

  useEffect(() => {
    let mounted = true
    getDataReturn()
    if (!mounted) {
      return false
    }
    return () => {
      mounted = false
    }
  }, [getDataReturn])

  if (!returnData) {
    return (
      <Loader />
    )
  }

  if(isWmoEnabled) {
    return (
      <ReturnDetailsWMO
        isDesktop={isDesktop}
        linkBreadcrumb={linkBreadcrumb}
        Link={Link}
        exitReturnDetails={exitReturnDetails}
        returnData={returnData}
        creditStatus={creditStatus}
        returnRequestStatus={returnRequestStatus}
        isCustomerTrackOrderRoute={isCustomerTrackOrderRoute}
      />
    )
  }

  return (
    <>
      <LightboxShippingLabel
        isDesktop={isDesktop}
        displayLightbox={displayLightbox}
        setDisplayLightbox={setDisplayLightbox}
        shippingLabelLightboxInstruction={shippingLabelLightboxInstruction}
      />
      {
        !isCustomerTrackOrderRoute && linkBreadcrumb.length > 0 && (
          <TempBreadcrumb
            links={linkBreadcrumb}
            Link={Link}
            exitReturnDetails={exitReturnDetails}
          />
        )
      }
      <Box
        width="1000px"
        margin={{ horizontal: 'auto', vertical: '0px' }}
        pad={getBoxPaddingValue()}
      >
        <ReturnDetailsHeader orderDetails={returnData} isDesktop={isDesktop} />
        <ReturnStatus
          orderDetails={returnData}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
          isDesktop={isDesktop}
          setDisplayLightbox={setDisplayLightbox}
          setShippingLabelLightboxInstruction={setShippingLabelLightboxInstruction}
          setDataChange={setDataChange}
          setDisplayReturnDetails={setDisplayReturnDetails}
          setReturnDetailsData={setReturnDetailsData}
        />
        <ReturnDetailsItemInfo orderDetails={returnData} isDesktop={isDesktop} />
        <ReturnDetailsFooter
          exitReturnDetails={exitReturnDetails}
          origin={origin}
          OpenChatHandler={OpenChatHandler}
        />
      </Box>
    </>
  )
}
